module.exports = __webpack_public_path__ + "img/switch_on.9e7f4d48.jpg";